
import Button from '@/ui-kit/components/button';
import { ButtonProperty, ButtonPropsEventType } from '@/ui-kit/components/button/enums';
import { StyleColorSchemeType, StyleSizeType } from '@/ui-kit/styles/enums';

export default {
  name: 'ProvinceButton',
  components: {
    Button,
  },
  props: {
    provinceText: {
      type: String,
      default: '',
    },
    activeProvince: {
      type: String,
      default: '',
    },
    provinceValue: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      ButtonProperty,
      ButtonPropsEventType,
      StyleSizeType,
    };
  },
  computed: {
    activeProvinceColor() {
      return this.provinceValue === this.activeProvince
        ? StyleColorSchemeType.Secondary
        : StyleColorSchemeType.White;
    },
  },
  methods: {
    handleButtonClick() {
      this.$emit(ButtonPropsEventType.Click, this.provinceValue);
    },
  },
};
